import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Reset scroll on page change (keeps #anchor navigation intact). */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
